import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(default)/developer/api/page.tsx");
